<template>
    <div class="login">
        <div class="loginForm">
            <h1 class="title">华蜂费用报销管理系统</h1>

            <span class="icon">
          <Icon type="ios-person"></Icon>

        </span>
            <div class="title" style="margin: 10px;">v1.0.401</div>
            <Form ref="loginForm" :model="login" :rules="rules" class="login-form">
                <FormItem prop="userAcount">
                    <Input type="text" style="width:360px" v-model="login.userAcount" placeholder="请输入用户名">
                        <Icon type="ios-person-outline" slot="prepend"/>
                    </Input>
                </FormItem>
                <FormItem prop="userPwd">
                    <Input type="password" style="width:360px" v-model="login.userPwd" placeholder="请输入密码">
                        <Icon type="ios-lock-outline" slot="prepend"/>
                    </Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" long @click="handleSubmit">登录</Button>
                </FormItem>
            </Form>
        </div>
    </div>
</template>

<script>
  import {loginRule} from '@/plugin/validateRule'

  export default {
    name: 'Login',
    data() {
      return {
        login: {
          userAcount: '',
          userPwd: ''
        },
        rules: loginRule
      }
    },
    methods: {
      handleSubmit() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.$fetch('SysUser/Login', this.login).then(res => {
              sessionStorage.setItem('userData', JSON.stringify(res.data))
              this.$Message.success({
                content: '登录成功',
                onClose: () => {
                  this.$router.push('/index')
                }
              })
            })
          }
        })
      }
    }
  }
</script>

<style lang="less">
    @import './login.less';
</style>
